import type { IServiceJourney } from '../../../models/service-journey.model';
import LineApiModel from './line.api-model';

export default class JourneyApiModel {
  public static mapToBusinessModel(apiModel: JourneyApiModel): IServiceJourney {
    return {
      gid: apiModel.gid,
      line: apiModel.line ? LineApiModel.mapToBusinessModel(apiModel.line) : undefined,
      direction: undefined,
      number: undefined,
    };
  }

  gid!: string;
  line!: LineApiModel;
}
